module Parameters
{
	export function construct()
	{
		$("select[data-switchParameterChange],input[data-switchParameterChange]").change((event) =>
		{
			const input = $(event.target);
			let val: any = input.val();
			if (input.is("input[type=checkbox]")) {
				val = input.is(":checked");
			}
			const parameterName = input.data("switchparameterchange");
			Parameters.setParameter(parameterName, val);
		});

		$("select[data-switchParameterBlur],input[data-switchParameterBlur]").blur((event) =>
		{
			const input = $(event.target);
			let val: any = input.val();
			if (input.is("input[type=checkbox]"))
			{
				val = input.is(":checked");
			}
			Parameters.setParameter(input.data("switchparameterblur"), val);
		});

		$("[data-switchParameterClick").click((event) => {
			const element = $(event.target);
			const attribute = (element.data("switchparameterclick") as string).split(',');//Value is like uid,fdcfa4f8-d38c-46ad-b80c-f173413ed3e3
			const parameter = attribute[0];
			const value = attribute[1];
			Parameters.setParameter(parameter, value);
		});
	}

	export function getParameter(name: string): string {
		const results = (new RegExp(`[\\?&]${name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")}=([^&#]*)`)).exec(location.search);
		return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}

	export function setParameter(parameter, value) {
		let url = window.location.href;
		const re = new RegExp(`([?&])${parameter}=.*?(&|#|$)(.*)`, "gi");
		let hash;

		if (re.test(url)) {
			if (typeof value !== "undefined" && value !== null)
				document.location.href = url.replace(re, `$1${parameter}=${value}$2$3`);
			else {
				hash = url.split("#");
				url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
				if (typeof hash[1] !== "undefined" && hash[1] !== null)
					url += `#${hash[1]}`;
				document.location.href = url;
			}
		} else {
			if (typeof value !== "undefined" && value !== null) {
				const separator = url.indexOf("?") !== -1 ? "&" : "?";
				hash = url.split("#");
				url = hash[0] + separator + parameter + "=" + value;
				if (typeof hash[1] !== "undefined" && hash[1] !== null)
					url += `#${hash[1]}`;
				document.location.href = url;
			} else
				document.location.href = url;
		}
	}
}